import React from 'react';
import { AuthContext } from './AuthContext.helpers';
import { AuthContextType } from './types';
import { useAuthState } from './useAuthState';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [state, actions] = useAuthState();
  
  const unreadNotificationsCount = state.notifications.filter(
    (notification) => !notification.read
  ).length;
  
  const contextValue: AuthContextType = {
    isAuthenticated: state.isAuthenticated,
    user: state.user,
    login: actions.login,
    register: actions.register,
    logout: actions.logout,
    notifications: state.notifications,
    unreadNotificationsCount,
    markNotificationAsRead: actions.markNotificationAsRead,
    deleteNotification: actions.deleteNotification,
    switchRole: actions.switchRole,
    impersonateUser: actions.impersonateUser,
    isLoadingAuth: state.isLoadingAuth,
    isLoggingOut: state.isLoggingOut ?? false,
  };
  
  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};
